<template>
    <!-- Passo veloce del checkout (#374): nome, cognome, e-mail, codice fiscale, termini. Al posto del modulo di registrazione completo. -->
    <form class="quick-signup-form mt-3" @submit.prevent="submit" novalidate>
        <h4 class="mb-2">Dati per l'acquisto</h4>
        <p class="small mb-3">Servono pochi dati per pagare. Il resto dei dati lo completi dopo, dal link che ti inviamo via e-mail.</p>

        <label class="form-label" for="qs-firstName">Nome</label>
        <input id="qs-firstName" v-model="form.firstName" class="form-control mb-2" autocomplete="given-name" />
        <label class="form-label" for="qs-lastName">Cognome</label>
        <input id="qs-lastName" v-model="form.lastName" class="form-control mb-2" autocomplete="family-name" />
        <label class="form-label" for="qs-email">E-mail</label>
        <input id="qs-email" v-model="form.email" type="email" class="form-control mb-2" autocomplete="email" />
        <label class="form-label" for="qs-taxCode">Codice fiscale</label>
        <input id="qs-taxCode" v-model="form.taxCode" class="form-control mb-2" maxlength="20" autocomplete="off" style="text-transform: uppercase" />

        <div class="form-check mb-2">
            <input id="qs-foreign" v-model="form.foreignTaxCode" type="checkbox" class="form-check-input" />
            <label class="form-check-label" for="qs-foreign">Ho un codice fiscale estero</label>
        </div>
        <div v-if="form.foreignTaxCode" class="mb-2">
            <label class="form-label" for="qs-gender">Genere</label>
            <select id="qs-gender" v-model="form.gender" class="form-select mb-2">
                <option value="">Seleziona</option>
                <option value="MALE">Maschio</option>
                <option value="FEMALE">Femmina</option>
            </select>
            <label class="form-label" for="qs-dob">Data di nascita</label>
            <input id="qs-dob" v-model="form.dateOfBirth" type="date" class="form-control" />
        </div>

        <div class="form-check mb-3">
            <input id="qs-terms" v-model="form.acceptedTerms" type="checkbox" class="form-check-input" />
            <label class="form-check-label" for="qs-terms">
                Accetto i <a href="https://elitefitness.it/terms/" target="_blank" rel="noopener">termini e condizioni</a>
                e l'<a href="https://elitefitness.it/privacy/" target="_blank" rel="noopener">informativa privacy</a>.
            </label>
        </div>

        <p v-if="error" class="text-warning mb-2" role="alert">{{ error }}</p>
        <button type="submit" class="btn btn-danger w-100" :disabled="busy">{{ busy ? 'Attendi…' : 'Continua' }}</button>
    </form>
</template>

<script>
import { validateQuickSignup, buildQuickSignupPayload, interpretSignupResponse } from '@/utils/quickSignup.js';

export default {
    name: 'QuickSignupForm',
    emits: ['signed-up', 'unavailable'],
    data() {
        return {
            busy: false,
            error: '',
            form: { firstName: '', lastName: '', email: '', taxCode: '', foreignTaxCode: false, gender: '', dateOfBirth: '', acceptedTerms: false },
        };
    },
    methods: {
        async submit() {
            if (this.busy) return;
            this.error = validateQuickSignup(this.form) || '';
            if (this.error) return;
            this.busy = true;
            try {
                const res = await fetch('https://api.elitefitness.it/api/auth/checkout-signup', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(buildQuickSignupPayload(this.form)),
                });
                let body = null;
                try { body = await res.json(); } catch (_) { /* corpo assente o non JSON */ }
                const outcome = interpretSignupResponse(res.status, body);
                if (outcome.ok) {
                    this.$emit('signed-up', { token: outcome.token, expiresIn: outcome.expiresIn, userId: outcome.userId, email: buildQuickSignupPayload(this.form).email });
                    return;
                }
                this.error = outcome.message;
                if (outcome.kind === 'disabled') this.$emit('unavailable');
            } catch (e) {
                this.error = 'Connessione non riuscita. Riprova.';
            } finally {
                this.busy = false;
            }
        },
    },
};
</script>
